import { useCallback, useContext, useEffect, useState } from 'react';
import { storesContext } from '../../../stores/storesContext';

const useUserReports = () => {
  const userStore = useContext(storesContext);
  const blockScanningStore = userStore.blockScanningStore;
  const [reportsOffset, setReportsOffset] = useState(
    blockScanningStore.userReports.length
  );
  const [hasMoreReports, setHasMoreReports] = useState(true);
  const reportsPageSize = 100;

  const fetchUserReports = useCallback(async () => {
    if (!userStore.selectedDatabase) return;
    const response = await blockScanningStore.fetchUserReports(
      reportsPageSize,
      reportsOffset
    );
    if (response.data && response.data.length < reportsPageSize) {
      setHasMoreReports(false);
      return;
    }
    if (!response.page) return;
    setReportsOffset(response.page.next_offset);
  }, [blockScanningStore, reportsOffset, userStore.selectedDatabase]);

  useEffect(() => {
    const fetchData = async () => {
      if (hasMoreReports) fetchUserReports();
    };
    fetchData();
  }, [fetchUserReports, hasMoreReports]);

  return blockScanningStore.userReports;
};

export default useUserReports;

